import {
    RADIO_TYPE,
    CHECKBOX_TYPE,
    CHECKBOX_BASED_BUTTON_TYPE


} from 'Constants/FormElement'
import RadioBasedButton from "./components/RadioBasedButton"
import CheckboxBasedButton from "./components/CheckboxBasedButton"
import { TabPane } from 'reactstrap'

export const FilterContent = ({ activeCriteria }: { activeCriteria: any }) => {
    console.log("activeCriteria", activeCriteria)
    const { id, type, contentJSON } = activeCriteria

    let html = null

    switch (type) {
        case RADIO_TYPE:
            html = 
                
                <RadioBasedButton contentJSON={contentJSON} />
            break;

            case CHECKBOX_BASED_BUTTON_TYPE:
            html =
            <h1>hello</h1>
            
            break;
        case CHECKBOX_TYPE:

        html = (
            <CheckboxBasedButton contentJSON={contentJSON}  />
        )
            break;

        default:
            break;
    }

    return <TabPane tabId={id}>{html}</TabPane>

}